import React from 'react';
import Container from './Container';
import Text from './Text';
import Image from './Image';
import Date from './Date';

export default ({ sale }) => (
  <Container>
    <Image src={sale.image} />
    <Text>{sale.title}</Text>
    <Date>{sale.updated_at}</Date>
  </Container>
);
